import { getLocalToday } from "utils/Common/Date";
import { createElement, useState } from "react";
import { type ReactElement } from "react";
import { pdf, type DocumentProps } from "@react-pdf/renderer";
import G702Pdf, { G702PdfProps } from "Components/Common/G702Pdf/G702Pdf";
import { DrawDetail } from "Pages/Admin/ProjectDetail/sections/DrawHistory/DrawHistory.types";

export const useG702Pdf = () => {
  const [isExportingG702, setIsExportingG702] = useState(false);

  const exportG702Pdf = async (
    drawDetail: DrawDetail | null,
    projectName?: string,
  ) => {
    if (!drawDetail) return;
    setIsExportingG702(true);
    try {
      const props: G702PdfProps = { drawDetail, projectName };
      const el = createElement(
        G702Pdf,
        props,
      ) as ReactElement<DocumentProps>;
      const blob = await pdf(el).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      const drawLabel = String(drawDetail.draw.drawNumber).padStart(2, "0");
      a.href = url;
      a.download = `G702-Draw-${drawLabel}-${projectName ?? "export"}-${getLocalToday()}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } finally {
      setIsExportingG702(false);
    }
  };

  return { exportG702Pdf, isExportingG702 };
};
